import { FieldConfig } from 'model/deals.model';
import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';
import { BaseDealForm } from '../BaseDealForm';

const BASE_FIELDS: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.category',
    label: 'Category',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.dealType',
    label: 'Deal type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.contractTerm',
    label: 'Contract term (month)',
    type: 'number',
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.exclusivityScope',
    label: 'Exclusivity scope',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientFitScore',
    label: 'Client fit score',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientApproval',
    label: 'Client approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.renewalProbability',
    label: 'Renewal probability (%)',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],

    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.careerStage',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 12,
  },
];

export const CommercialEndorsement = () => {
  const [fields, setFields] = useState<FieldConfig[]>(BASE_FIELDS);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const dealTypeKey = 'COMMERCIAL_ENDORSEMENT';
        const dropdownsData = await DealsService.getDealDropdowns(dealTypeKey);
        const updatedFields = BASE_FIELDS.map((field) => {
          if (field.type === 'select' && field.options) {
            let options: string[] = [];

            switch (field.name) {
              case 'dealDetails.stageName':
                if (dropdownsData.stages && Array.isArray(dropdownsData.stages)) {
                  options = dropdownsData.stages.map((stage: any) => stage.stageName);
                }
                break;
              case 'dealDetails.category':
                if (dropdownsData.category && Array.isArray(dropdownsData.category)) {
                  options = [...dropdownsData.category];
                }
                break;
              case 'dealDetails.dealType':
                if (dropdownsData.dealType && Array.isArray(dropdownsData.dealType)) {
                  options = [...dropdownsData.dealType];
                }
                break;
              case 'dealDetails.exclusivityScope':
                if (
                  dropdownsData.exclusivityScope &&
                  Array.isArray(dropdownsData.exclusivityScope)
                ) {
                  options = [...dropdownsData.exclusivityScope];
                }
                break;
              case 'dealDetails.clientApproval':
                if (dropdownsData.clientApproval && Array.isArray(dropdownsData.clientApproval)) {
                  options = [...dropdownsData.clientApproval];
                }
                break;
              case 'dealDetails.renewalProbability':
                if (
                  dropdownsData.renewalProbability &&
                  Array.isArray(dropdownsData.renewalProbability)
                ) {
                  options = [...dropdownsData.renewalProbability];
                }
                break;
              case 'dealDetails.clientOrientation':
                if (
                  dropdownsData.clientOrientation &&
                  Array.isArray(dropdownsData.clientOrientation)
                ) {
                  options = [...dropdownsData.clientOrientation];
                }
                break;
              case 'dealDetails.revenueTier':
                if (dropdownsData.revenueTier && Array.isArray(dropdownsData.revenueTier)) {
                  options = [...dropdownsData.revenueTier];
                }
                break;
              case 'dealDetails.clientFitScore':
                if (dropdownsData.clientFitScore && Array.isArray(dropdownsData.clientFitScore)) {
                  options = [...dropdownsData.clientFitScore];
                }
                break;
              case 'dealDetails.careerStage':
                if (dropdownsData.careerStage && Array.isArray(dropdownsData.careerStage)) {
                  options = [...dropdownsData.careerStage];
                }
                break;
              default:
                options = field.options ? [...field.options] : [];
            }

            return {
              ...field,
              options: options.length > 0 ? options : field.options ? [...field.options] : [],
            };
          }
          return field;
        });

        setFields(updatedFields);
      } catch (error) {
        console.error('Failed to fetch dropdown values:', error);
        setFields(BASE_FIELDS);
      }
    };

    fetchDropdowns();
  }, []);

  return <BaseDealForm fields={fields} />;
};
